var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home flex"},[_c('ContactList',{staticClass:"home--contacts scrollable__y hidden md:block md:w-1/4"}),_c('ConversationContainer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }